import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const Option = styled.option`
  padding: 0.5rem;
  background-color: #393939;
  color: #f2f2f2;
`;

export const Select = styled.select`
  color: #f2f2f2;
  background-color: transparent;
  border: 1px solid #505050;
  padding: 0.5rem;
  font-size: 1rem;
  cursor: pointer;
`;

export const LinearScaleContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;

export const LinearScaleItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const LinearScaleItemLabel = styled.label`
  font-size: 1rem;
  font-weight: 500;
`;

export const LinearScaleItemInput = styled.input`
  background-color: transparent;
  border: 1px solid #505050;
  color: #f2f2f2;
  border-radius: 0.25rem;
  padding: 0.5rem;
  width: 5rem;
`;

export const LinearScaleMarkerInput = styled.input`
  background-color: transparent;
  border: 1px solid #505050;
  color: #f2f2f2;
  border-radius: 0.25rem;
  padding: 0.5rem;
  width: 10rem;
`;

export const ReadOnlyText = styled.p`
  font-size: 1rem;
  font-weight: 600;
  margin: 0;
`;

export const ReadOnlySelect = styled.select`
  display: block;
  width: 100%;
  background-color:#393939;
  border: 1px solid #505050;
  color: #fff;
  padding: 0.25rem;
  cursor: pointer;
  margin-top: 0.5rem;
`;

export const ReadOnlySelectOption = styled.option`

`;

export const SelectQuestionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const SelectQuestionMultipleSelectionLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
`;

export const SelectQuestionMultipleSelectionCheckbox = styled.input``;

export const SelectQuestionOptionContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
`;

export const SelectQuestionOptionInput = styled.input`
  width: 100%;
  border: 1px solid #505050;
  color: #fff;
  background-color: transparent;
  padding: 0.5rem;
`;

export const SelectQuestionOptionActions = styled.div`
  display: flex;
  align-items: center;
`;

export const SelectQuestionOptionActionButton = styled.button`
  background-color: transparent;
  border: none;
  display: flex;
  color: #fff;
  font-size: 1.25rem;
  cursor: pointer;
  padding: 0.25rem;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const SelectQuestionNewOptionButton = styled.button`
  border: 1px solid #505050;
  color: #fff;
  background-color: transparent;
  padding: 0.5rem 0.5rem;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  cursor: pointer;
`;